var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('h1',[_vm._v("We're taking time out for maintenance")]),_c('p',[_vm._v("We'll be back soon")]),_c('img',{attrs:{"alt":"Maintenance logo","src":"/assets/2344483.png"}})])
}]

export { render, staticRenderFns }